import negativeList from './negativeList'

export const negativeListService = negativeList
